function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { AddOutlinedIcon, EditIcon } from '../icons';
import BaseButton from './BaseButton';
import IconButtonGy from './IconButtonGy';
import LinkButton from './LinkButton';
import SplitButton from './SplitButton';
import { basePropTypes, StyledButton } from './utils';
const ContainedButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({
  variant: "contained"
}, props));
const OutlinedButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({
  variant: "outlined"
}, props));
const TextButton = props => /*#__PURE__*/React.createElement(BaseButton, props);
const CreateButton = props => /*#__PURE__*/React.createElement(ContainedButton, _extends({}, props, {
  color: props.color || 'primary',
  text: props.text || 'Create'
}));
const SaveButton = props => /*#__PURE__*/React.createElement(ContainedButton, _extends({}, props, {
  type: "submit",
  color: props.color || 'primary',
  text: props.text || 'Save'
}));
const CancelButton = props => /*#__PURE__*/React.createElement(OutlinedButton, _extends({}, props, {
  color: props.color || 'secondary',
  text: props.text || 'Cancel'
}));
const IconButtonAdd = props => /*#__PURE__*/React.createElement(IconButtonGy, _extends({}, props, {
  icon: AddOutlinedIcon,
  label: props.label || 'Add'
}));
const IconButtonEdit = props => /*#__PURE__*/React.createElement(IconButtonGy, _extends({}, props, {
  icon: EditIcon,
  label: props.label || 'Edit'
}));
const CustomButton = ({
  text,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(StyledButton, rest, text, children);
};
const IconTextButton = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  color: "primary",
  variant: "contained",
  startIcon: props?.icon
}), props?.text);
const IconTextButtonOutlined = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  variant: "outlined",
  startIcon: props?.icon
}), props?.text);
const IconTextButtonNonPrimary = props => /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
  variant: "contained",
  startIcon: props?.icon
}), props?.text);
CustomButton.propTypes = basePropTypes;
ContainedButton.propTypes = basePropTypes;
TextButton.propTypes = basePropTypes;
LinkButton.propTypes = basePropTypes;
CreateButton.propTypes = {
  ...basePropTypes,
  float: PropTypes.string
};
OutlinedButton.propTypes = basePropTypes;
SaveButton.propTypes = basePropTypes;
CancelButton.propTypes = basePropTypes;
IconButtonAdd.propTypes = {
  ...basePropTypes,
  children: PropTypes.any,
  label: PropTypes.string
};
IconButtonEdit.propTypes = {
  ...basePropTypes,
  children: PropTypes.any,
  label: PropTypes.string
};
export { TextButton as Button, CancelButton, ContainedButton, CreateButton, CustomButton, IconButtonGy as IconButton, IconButtonAdd, IconButtonEdit, IconTextButton, IconTextButtonNonPrimary, IconTextButtonOutlined, LinkButton, OutlinedButton, SaveButton, SplitButton, TextButton };